import React from 'react';
import { useGetProductDetailsQuery } from '../../slices/productApiSlice';
import { FaFire } from 'react-icons/fa';

const CartProductUrgency = ({ productId }) => {
    const { data: product } = useGetProductDetailsQuery(productId);

    if (!product || !product.inCarts || product.inCarts === 0) return null;

    return (
        <div className="d-flex align-items-center text-danger small fw-bold mt-1" style={{ fontSize: '0.7rem' }}>
            <FaFire className="me-1" />
            {product.inCarts} {product.inCarts === 1 ? 'persona lo tiene' : 'personas lo tienen'} en su carrito
        </div>
    );
};

export default CartProductUrgency;
